﻿export default (function($) {
    this.init = () => {
        this.EPiServerFormsCaptchaCustom();
    };

    this.EPiServerFormsCaptchaCustom = () => {
        //console.log(epi.EPiServer.Forms); document.getElementById('divElem').scrollTop
        var m_capchaForm;
        var m_captchItem;

        $('form.EPiServerForms').each(function () {
            m_capchaForm = $(this);

            var successItem = m_capchaForm.find('.Form__Success__Message')
            if (successItem.length > 0)
                m_capchaForm.scrollTop();

            if (HasFormCaptcha()) {
                var isPostError = $(this).hasClass('ValidationFail');

                if (isPostError) {
                    m_captchItem.find('.FormCaptcha__Input').focus();
                    m_captchItem.show();
                    m_capchaForm.find('.FormTextbox').hide();
                }
                else
                    m_captchItem.hide();

                HandleCaptchaOnSubmit();
            }
        });

        function HasFormCaptcha() {
            m_captchItem = m_capchaForm.find('.FormCaptcha');
            return m_captchItem.length > 0;
        }

        function HandleCaptchaOnSubmit() {
            $(m_capchaForm).submit(function (event) {
                var captchaItem = $(this).find('.FormCaptcha');
                var visible = captchaItem.is(":visible");
                if (!visible) {
                    $(this).find('.FormTextbox').hide();
                    captchaItem.show();
                    event.preventDefault();
                }
            });
        }
    };

    return this.init;
}).call({}, jQuery);